import { rtkApi } from '../../rtkApi';

export type AddendumTemplateType =
  | 'extension'
  | 'repair_request'
  | 'name_change'
  | 'general'
  | 'amendment'
  | 'attachment'
  | 'other';

export interface AddendumTemplate {
  _id: string;
  type: AddendumTemplateType;
  title: string;
  body: string;
  placeholders: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAddendumTemplateRequest {
  type: AddendumTemplateType;
  title: string;
  body: string;
  placeholders?: string[];
  isActive?: boolean;
}

export interface UpdateAddendumTemplateRequest {
  templateId: string;
  update: Partial<CreateAddendumTemplateRequest>;
}

export const addendumTemplateApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getAddendumTemplates: builder.query<AddendumTemplate[], void>({
      query: () => ({
        url: '/admin/addendum-templates',
        method: 'GET',
      }),
      transformResponse: (response: {
        success: boolean;
        data: AddendumTemplate[];
      }) => response.data,
      providesTags: ['AddendumTemplates'],
    }),
    createAddendumTemplate: builder.mutation<
      AddendumTemplate,
      CreateAddendumTemplateRequest
    >({
      query: (data) => ({
        url: '/admin/addendum-templates',
        method: 'POST',
        data,
      }),
      transformResponse: (response: {
        success: boolean;
        data: AddendumTemplate;
      }) => response.data,
      invalidatesTags: ['AddendumTemplates'],
    }),
    updateAddendumTemplate: builder.mutation<
      AddendumTemplate,
      UpdateAddendumTemplateRequest
    >({
      query: ({ templateId, update }) => ({
        url: `/admin/addendum-templates/${templateId}`,
        method: 'PUT',
        data: update,
      }),
      transformResponse: (response: {
        success: boolean;
        data: AddendumTemplate;
      }) => response.data,
      invalidatesTags: ['AddendumTemplates'],
    }),
    deleteAddendumTemplate: builder.mutation<{ success: boolean }, string>({
      query: (templateId) => ({
        url: `/admin/addendum-templates/${templateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AddendumTemplates'],
    }),
  }),
});

export const {
  useGetAddendumTemplatesQuery,
  useCreateAddendumTemplateMutation,
  useUpdateAddendumTemplateMutation,
  useDeleteAddendumTemplateMutation,
} = addendumTemplateApi;
